
import { Component, Prop, Vue } from "vue-property-decorator";
import { ICoupon } from "@/store/interfaces/coupon";
import { discountSize } from "@/services/discountSize.ts";
import isImgCorrect from "@/services/isImgCorrect.ts";

@Component({
  name: "CouponPopup",
  methods: {
    discountSize
  }
})
export default class CouponPopup extends Vue {
  @Prop() coupon: ICoupon;

  inputValue: string = this.coupon["coupon_code"];
  isTextCopy: boolean = false;
  isHasCode: boolean = false;
  isShowImg: boolean = true;

  created() {
    this.isHasCode = this.isCodeHasCheck();
  }

  async mounted() {
    this.isShowImg = await isImgCorrect(this.coupon.img);
  }

  isCodeHasCheck(): boolean {
    return (
      this.inputValue === this.$i18n.t("Z4") ||
      /(НЕ НУЖЕН)|(NOT REQUIRED)/i.test(this.inputValue)
    );
  }

  handleClose() {
    this.$store.dispatch("app/togglePopupAction");
  }

  handleOpenUrl() {
    window.open(this.coupon.url, "_self");
  }

  handleCopyCode() {
    if (this.isHasCode || this.isTextCopy) {
      return;
    }
    this.$refs.codeInput["select"]();
    document.execCommand("copy");
    this.isTextCopy = true;
    this.inputValue = `${this.$i18n.t("Z5")}`;
  }
}
